module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Immortalaeism II")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_c('b', [_vm._v("About the Author")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_c('b', [_vm._v("Copyright Information ©")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#power-ii"
    }
  }, [_c('b', [_vm._v("POWER II")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#prime-cause"
    }
  }, [_c('b', [_vm._v("1. Prime Cause")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#first-cause"
    }
  }, [_vm._v("1.1 First Cause")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#possessors"
    }
  }, [_vm._v("1.2 Possessors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#statements"
    }
  }, [_vm._v("1.3 Statements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#the-truth-prime-laws-of-immortalae"
    }
  }, [_vm._v("1.4 The Truth Prime Laws of Immortalae")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#virtue"
    }
  }, [_c('b', [_vm._v("2. Virtue")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#training-in-virtue"
    }
  }, [_vm._v("2.1 Training in Virtue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#perfected-virtue"
    }
  }, [_vm._v("2.2 Perfected Virtue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#selecting-virtues"
    }
  }, [_vm._v("2.3 Selecting Virtues")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#code-of-morality"
    }
  }, [_vm._v("2.4 Code of Morality")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#virtue-and-power"
    }
  }, [_vm._v("2.5 Virtue and Power")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#constancy"
    }
  }, [_vm._v("2.6 Constancy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#pillar-of-virtue"
    }
  }, [_vm._v("2.7 Pillar of Virtue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#aim-of-religion"
    }
  }, [_vm._v("2.8 Aim of Religion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#immortal-energy"
    }
  }, [_vm._v("2.9 Immortal Energy")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#error"
    }
  }, [_c('b', [_vm._v("3. Error")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#destruction"
    }
  }, [_vm._v("3.1 Destruction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#universality-and-error"
    }
  }, [_vm._v("3.2 Universality and Error")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#futility-and-human-endeavour"
    }
  }, [_vm._v("3.3 Futility and Human Endeavour")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#error-and-mutability"
    }
  }, [_vm._v("3.4 Error and Mutability")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#error-opposes-perfection-part-i"
    }
  }, [_vm._v("3.5 Error Opposes Perfection (Part I)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#error-opposes-perfection-part-ii"
    }
  }, [_vm._v("3.5 Error Opposes Perfection (Part II)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#moral-error"
    }
  }, [_vm._v("3.6 Moral Error")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#conclusion-of-error"
    }
  }, [_vm._v("3.7 Conclusion of Error")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0001#success",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. Success")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-2000"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0001#the-way-of-success",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1 The Way of Success")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0001#power-in-advancement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2 Power in Advancement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0001#absolutism-of-advancement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3 Absolutism of Advancement")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#prophecyfate-destiny",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. Prophecy/Fate/ Destiny")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#introduction-to-prophecy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1 Introduction to Prophecy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#normative-prophetic-experience",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2 Normative Prophetic Experience")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#manifest-predestination",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3 Manifest Predestination")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#prophecy-and-immortalaeism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4 Prophecy and Immortalaeism")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#fates-grande-order",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5 Fates Grande Order")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#fate-and-destiny",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6 Fate and Destiny")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#accepting-destiny",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.7 Accepting Destiny")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#realitythe-universe",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. Reality/the Universe")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-metaphysics-of-power-revisited",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1 The Metaphysics of Power (Revisited)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#power-in-series",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2 Power in Series")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#spiritual-boundary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.3 Spiritual Boundary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-universe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.4 The Universe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#reality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.5 Reality")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-astral",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.6 The Astral")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#serialism",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7. Serialism")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#introduction-to-serialism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1 Introduction to Serialism")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#transference-and-inference",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2 Transference and Inference")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#vauls-number-sequence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.3 Vaul’s Number Sequence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#power-and-alignment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.4 Power and Alignment")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#concept-art",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8. Concept-Art")])]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#introduction-to-concept-art",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.1 Introduction to Concept-Art")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#other-worlds.-concept-and-symbolism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.2 Other Worlds. Concept and Symbolism")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-world-of-concept-art-and-its-interconnectedness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.3 The World of Concept-Art and its Interconnectedness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#blessings-and-curses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.4 Blessings and Curses")])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#power-iii",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("POWER III")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#logic",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1. Logic")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#reality-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. Reality")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#essence",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. Essence")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#consciousness",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. Consciousness")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#baptism",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. Baptism")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#substance",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. Substance")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#forma",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7. Forma")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#in-demonstration",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8. In Demonstration")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#hero",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("HERO")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#hero-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hero")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#fidelity",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Fidelity")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#immortality",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Immortality")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#normalism",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Normalism")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#power",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Power")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#leader",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Leader")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#insignia",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Insignia")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#icon",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Icon")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#concept-hero",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Concept Hero")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#alter",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Alter")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#civilization",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Civilization")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#arcade",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Arcade")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#dragon",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Dragon")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#double-dragon",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Double-Dragon")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#dragon-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("DRAGON")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#darkness",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Darkness")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#martial-arts",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Martial Arts")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#dragon-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Dragon")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#civilization-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Civilization")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0